import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const AuthenticationLogSchema = withDefaults({
  type: 'authentication-log',
  fields: [
    {
      kind: 'attribute',
      name: 'identity',
    },
    {
      kind: 'attribute',
      name: 'ipAddress',
    },
    {
      kind: 'attribute',
      name: 'loginAttemptStatus',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default AuthenticationLogSchema;
